import { useContext } from 'react';

import * as graphql from 'generated/graphql';
import AuthorizationContext from 'packages/kakapo-ui-application/contexts/AuthorizationContext';

export default function useViewer(): graphql.User | undefined {
	const context = useContext(AuthorizationContext)!;

	return context?.authenticatedUser ?? undefined;
}
